
function requestAPI(id, token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}agent/password/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionResetPasswordAgent(id) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'RESET_PASSWORD_AGENT_BEGIN'
    })

    try {
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(id, token)
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'RESET_PASSWORD_AGENT_SUCCESS',
        success: result
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'RESET_PASSWORD_AGENT_FAILURE',        
    error: error    
  })
}